import React from "react";
import Modal from "../../../../elements/Modal";
import ManageDonation from "../ManageDonation";
import RecurringDonation from "../RecurringDonation";

const RecurringDonationModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      // title={
      //   <div>
      //     <div>Email Receipt</div>
      //     <p className="font-medium text-xl">Thank You for Your Donation to the V’Peters Family Scholarship!</p>
      //   </div>
      // }
      title={"Create Recurring Transaction"}
    >
      <RecurringDonation getResponse={getResponse} close={close} details={data} />
    </Modal>
  );
};

export default RecurringDonationModal;
